import { LatLngBounds } from "leaflet";
import { ILayerBounds } from "types/IForecastMap";

export const getTilePathByBounds = (
  paths: { [key: string]: string },
  modelBounds: ILayerBounds,
  tileBounds: [[number, number], [number, number]],
  coords: { x: number; y: number; z: number }
) => {
  const tileBoundsObject = new LatLngBounds(tileBounds);
  for (const modelBoundKey in modelBounds) {
    const modelBound = new LatLngBounds(modelBounds[modelBoundKey]);
    if (modelBound.intersects(tileBoundsObject)) {
      const path = paths[modelBoundKey];
      if (path) {
        return replaceXYZ(path, coords);
      }
    }
  }
  return "";
};

const replaceXYZ = (
  template: string,
  coords: { x: number; y: number; z: number }
) => {
  return template
    .replace("{x}", coords.x.toString())
    .replace("{y}", coords.y.toString())
    .replace("{z}", coords.z.toString());
};
